import React from 'react'
import { NavLink } from 'react-router-dom'
import { FaEnvelope, FaMapMarker, FaPhoneAlt } from 'react-icons/fa'
import secure from '../assets/images/download.png';
import trustpilot from '../assets/images/reviews.248291f3.webp';

const Footer = ({ settings }) => {

  const currentYear = new Date().getFullYear();

  return (
    <div>
      <footer className="text-center text-lg-start text-muted" style={{ backgroundColor: "#064877" }}>
        <div className="py-5 text-white">
          <div className="container">
            <div className="row">
              <div className="col-md-3 mb-4">
                <h5 className="fw-bold">About Us</h5>

                <img
                  src="https://firebasestorage.googleapis.com/v0/b/bmb-reactjs.appspot.com/o/logo-dark.webp?alt=media&token=2c964bb1-f68d-4226-978d-576fb289b41d"
                  alt="BakeMyBook Logo"
                  style={{ width: "150px", marginBottom: "1rem" }}
                />

                <p className="mb-0 fw_400">
                  BakeMyBook is a boutique self-publishing agency offering expert editing,
                  design, audiobook and global book distribution. Our passionate team
                  partners closely with authors to deliver high-quality, personalized
                  results without hidden fees or shortcuts. We launch books with care,
                  creativity, and professionalism.
                </p>
              </div>
              <div className="col-md-3 mb-4">
                <h5 className="fw-bold">Services</h5>
                <ul className="list-unstyled">
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/book-publishing">Book Publishing</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/book-cover-design">Book Cover Design</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/ebook-ghost-writing">Book Ghostwriting</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/book-editing">Book Editing</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/audio-book">Audiobook</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/book-marketing">Book Marketing</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/book-formatting">Book Formatting</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/childrens-book">Children's Illustrations</NavLink></li>
                  <li className="mb-2">• <NavLink className="text-white text-decoration-none" to="/author-website">Author Website</NavLink></li>
                </ul>
              </div>
              <div className="col-md-3 mb-4">
                <h5 className="fw-bold">Company</h5>

                <p className="mb-1 fw-bold">HEAD OFFICE:</p>
                <p>3461, Towne Blvd, Middletown, OH 45005</p>

                <p className="mb-1 fw-bold">Mailing Address:</p>
                <p>2 Shannon Dr, Woodbury, NY 11797</p>

                <a
                  href="https://www.trustpilot.com/review/bakemybook.com?utm_medium=trustbox&utm_source=TrustBoxReviewCollector"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={trustpilot}
                    className="img-fluid"
                    alt="Trustpilot Reviews"
                  />
                </a>
              </div>
              <div className="col-md-3 mb-4">
                <h5 className="fw-bold">Secure Payment</h5>
                <img
                  src={secure}
                  alt="Secure Payment"
                  className="img-fluid"
                />
              </div>



            </div>
          </div>
        </div>


        <div className="text-center border-top text-white bg-black p-4 fs_16 fw_600" style={{ backgroundColor: "rgba(0, 0, 0, 0.05);" }}>
          © {currentYear} Copyright:{" "}
          <NavLink className="text-decoration-underline fs_16 fw_600" to="/">BakeMyBook</NavLink>
        </div>
        {/* <div className="text-center border-top text-white bg__blue p-4 fs_16 fw_600" style={{ backgroundColor: "rgba(0, 0, 0, 0.05);" }}>
          <p className='fs_13 text-center text-white '>Disclaimer:<br />The services provided by BakeMyBook become clients' property once delivered. BakeMyBook will not hold any ownership<br /> rights once your work is successfully accepted by a publishing house.</p>
        </div> */}
      </footer>
    </div>
  )
}

export default Footer